import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface sliceState {
  isClose: boolean;
  isToggled: boolean;
  isSmallScreen: boolean;
  screenSize: number;
}

const initialState: sliceState = {
  isClose: true,
  isToggled: false,
  isSmallScreen: false,
  screenSize: 0,
};

const ToggleSlice = createSlice({
  name: "toggle-sidebar",
  initialState,
  reducers: {
    toggleChange: (state: any, action: PayloadAction<boolean>) => {
      state.isClose = action.payload;
    },

    onToggle: (state: any, action: PayloadAction<boolean>) => {
      state.isToggled = action.payload;
    },

    onResize: (
      state: any,
      action: PayloadAction<{ isSmallScreen: boolean; screenSize: number }>
    ) => {
      state.isSmallScreen = action.payload.isSmallScreen;
      state.screenSize = action.payload.screenSize;
    },
  },
});

export const { toggleChange, onToggle, onResize } = ToggleSlice.actions;
export const sidebarReducer = ToggleSlice.reducer;
